import { ButtonGroup, MenuItem, MenuList } from "@mui/material";
import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";
import { FiEdit, FiEye, FiTrash2, FiCopy } from "react-icons/fi";

import { Button } from "../../../../../../components/Form";

export const Wrapper = styled("div")(() => ({
  padding: "24px 24px 0 24px",
}));

export const BadgeInactive = styled("div")(() => ({
  background: "#FEF3F2 !important",
  color: "#D92D20 !important",

  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "8px 12px",
  height: "32px",
  borderRadius: "100px",
  whiteSpace: "nowrap",
  width: "fit-content",
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "16px",
}));

export const BadgeActive = styled(BadgeInactive)(() => ({
  background: "#ECFDF3 !important",
  color: "#039855 !important",
}));

export const EditIcon = styled(FiEdit)(() => ({
  cursor: "pointer",
}));

export const ViewIcon = styled(FiEye)(() => ({
  cursor: "pointer",
}));

export const DeleteIcon = styled(FiTrash2)(() => ({
  cursor: "pointer",
}));

export const CloneIcon = styled(FiCopy)(() => ({
  cursor: "pointer",
}));

export const StyledButtonGroup = styled(ButtonGroup)(() => ({
  "& *": {
    color: `${colors.brandBlue500} !important`,
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    letterSpacing: "0.1px",
    lineHeight: "20px",
    whiteSpace: "nowrap",

    ":disabled": {
      color: `${colors.gray400} !important`,
    },
  },

  "& > *": {
    border: `1px solid !important`,
    borderColor: `${colors.brandBlue500} !important`,
    borderRadius: "8px",

    ":active": {
      // 29 => 16% of opacity in hex (16% of 255 === 40.8 or 0x29)
      backgroundColor: `${colors.brandBlue500}29 !important`,
    },

    ":hover": {
      // 14 => 8% of opacity in hex (8% of 255 === 20.4 or 0x14)
      backgroundColor: `${colors.brandBlue500}14 !important`,
    },
  },

  "& :not(:last-child)": {
    borderBottomRightRadius: 0,
    borderRightColor: "transparent",
    borderTopRightRadius: 0,
  },
}));

export const StyledButton = styled(Button)(() => ({
  alignItems: "center",
  display: "flex",
  flex: "1 0 0",
  gap: "8px",
  justifyContent: "center",
  padding: "10px 12px 10px 16px",
}));

export const StyledButtonChevron = styled(Button)(() => ({
  alignItems: "center",
  display: "inline-flex",
  flexDirection: "column",
  flexShrink: 0,
  gap: "8px",
  height: "40px",
  justifyContent: "center",
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  color: `${colors.gray600} !important`,
  fontFamily: "Manrope",
  fontSize: "14px !important",
  fontStyle: "normal",
  fontWeight: 400,
  letterSpacing: "0.25px !important",
  lineHeight: "20px !important",
  padding: "8px 12px !important",
}));

export const StyledMenuList = styled(MenuList)(() => ({
  padding: "4px 0px !important",
}));
